import React from 'react'
import Header from '../Integration/DashboardHeader'
import SideBarMenu from '../Integration/DashboardSideBarMenu'
import FormBuscaProd from '../Integration/DashboardBuscaProduct'

function DashboardSearchProduto() {
  return (
    <div>
        
        
 
      <div className="homeheader">
        <Header/>

      </div>

     <div className="homebody">



      <div className="homeleft">

      <SideBarMenu/>

      </div>
      <div className="homeright">

        <div className="upright">

          <  label  className='label' ></label>
        </div>
        <div className="downright">
        <FormBuscaProd/>
        </div>
        <div className='footageright'>

        </div>

      </div>
     </div>
        



    </div>
  )
}

export default DashboardSearchProduto